export default "__VITE_ASSET__D8d7URFs__"